import Utils from './Utils.js';

class PaginationHelper { 

    static shrinkStr(str, preCharLength, postCharLength, strInBetween){
        if(Utils.isEmpty(str) || Utils.isEmpty(preCharLength) || Utils.isEmpty(postCharLength)) return str;
        return str.substring(0, preCharLength) + strInBetween + str.substring(str.length - postCharLength, str.length);
    }
}

export default PaginationHelper;
